module.exports = __webpack_public_path__ + "img/fun-1.8be858c9.png";